import StepperNav from './stepperNav';
import LoadingContainer from 'src/components/ui/loading/loading-container';
const DeviceSetupFormContainer = ({isLoading=false, title, currentStep,step, setStep, isValid, stepperPrev, stepperNext, isNextSubmit, formStatus,handleSubmit,children }) => {

    
    return ( 
        <>
        {step ===currentStep &&
            <form onSubmit={handleSubmit} className='relative'  autoComplete="off" >
               
                        
             
                    <div className='flex flex-row justify-between'>
                    <h2 className='text-sm font-semibold text-gray-700 '>{title}</h2>
                    {!formStatus?.isError && formStatus?.message !="" &&
                        <span className={` p-1 text-sm  text-vekin inline-flex gap-1 bg-vekin-green-40/30 rounded-md px-2`}>
                        <i className="ri-checkbox-circle-line"></i>{formStatus?.message}
                        </span> 
                    }
                    </div>
                <div className="relative grid grid-cols-1 gap-4 pb-8 mt-3 md:grid-cols-2">

                    {isLoading &&
                    <div className='absolute w-full h-full bg-white/70 z-60'>
                        <LoadingContainer isLoading={isLoading} isError={false} />
                    </div> }

                    {!isLoading && <>
                        { children}
                    </>}

                    {formStatus?.isError &&  
                        <span className={`absolute p-1 text-sm -bottom-3 text-red-500 inline-flex gap-1`}>
                        <i className="ri-error-warning-fill"></i> {formStatus?.message}
                        </span> 
                    }

                    
                </div>

                <StepperNav  step={step} setStep={setStep} isValid={isValid}  prev={stepperPrev} next={stepperNext} isNextSubmit={isNextSubmit}/>

            </form>
        }
    </>
     );
}
 
export default DeviceSetupFormContainer;


const test = {
    "name": "HV20A0041096",
    "model": 3,
    "description": "dfdfddfd",
    "config": "{\"performance\":{\"renew\":1,\"load\":1},\"external_type\":{\"name\":\"Dongle\",\"code\":62}}",
    "device_external_code": 156061144555799,
    "measurement": "dfdfdfd",
    "property": "[{\"name\":\"Phase A current of grid\",\"unit\":\"A\",\"field\":\"_a_i\",\"type\":\"Float32\",\"address\":1},{\"name\":\"B-C line voltage of grid\",\"unit\":\"V\",\"field\":\"_bc_u\",\"type\":\"Float32\",\"address\":2}]",
    "physical_type": 2,
    "type": "Wind Turbine",
    "device_type": "Wind Turbine",
    "place": 24
}